const BaseColor = '#9f1d21';
export default BaseColor;
